/* tslint:disable */
/* eslint-disable */
/**
 * HashiCorp Cloud Platform Vagrant Box Registry
 * API for managing Vagrant boxes.
 *
 * The version of the OpenAPI document: 2022-09-30
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime';
import { HashicorpCloudVagrant20220930SearchIndexResponseFromJSON, } from '../models';
/**
 *
 */
export class IndexServiceApi extends runtime.BaseAPI {
    /**
     * Search returns a list of available boxes based on search parameters
     */
    async searchRaw(requestParameters) {
        const queryParameters = {};
        if (requestParameters.q !== undefined) {
            queryParameters['q'] = requestParameters.q;
        }
        if (requestParameters.providers) {
            queryParameters['providers'] = requestParameters.providers;
        }
        if (requestParameters.sortOrderBy) {
            queryParameters['sort.order_by'] = requestParameters.sortOrderBy;
        }
        if (requestParameters.paginationPageSize !== undefined) {
            queryParameters['pagination.page_size'] = requestParameters.paginationPageSize;
        }
        if (requestParameters.paginationNextPageToken !== undefined) {
            queryParameters['pagination.next_page_token'] = requestParameters.paginationNextPageToken;
        }
        if (requestParameters.paginationPreviousPageToken !== undefined) {
            queryParameters['pagination.previous_page_token'] = requestParameters.paginationPreviousPageToken;
        }
        if (requestParameters.architectures) {
            queryParameters['architectures'] = requestParameters.architectures;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/vagrant/2022-09-30/search`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudVagrant20220930SearchIndexResponseFromJSON(jsonValue));
    }
    /**
     * Search returns a list of available boxes based on search parameters
     */
    async search(q, providers, sortOrderBy, paginationPageSize, paginationNextPageToken, paginationPreviousPageToken, architectures) {
        const response = await this.searchRaw({ q: q, providers: providers, sortOrderBy: sortOrderBy, paginationPageSize: paginationPageSize, paginationNextPageToken: paginationNextPageToken, paginationPreviousPageToken: paginationPreviousPageToken, architectures: architectures });
        return await response.value();
    }
}
